export const dashboardQueryKeys = {
  hospitals: () => ['dashboard', 'hospitals'] as const,
  branches: (hospitalId: string) => ['dashboard', 'branches', hospitalId] as const,
  users: () => ['dashboard', 'users'] as const,
  roles: () => ['dashboard', 'roles'] as const,
  organizationSettings: () => ['dashboard', 'organization-settings'] as const,
  systemSettings: () => ['dashboard', 'system-settings'] as const,
  localizationSettings: () => ['dashboard', 'localization-settings'] as const,
  license: () => ['dashboard', 'license'] as const,
  narcoticDrugs: () => ['dashboard', 'pharmacy', 'narcotic-drugs'] as const,
  stockValuation: () => ['dashboard', 'pharmacy', 'stock-valuation'] as const,
  pendingApprovalsSummary: () => ['dashboard', 'pharmacy', 'pending-approvals-summary'] as const,
  stockBatchExpiry: () => ['dashboard', 'pharmacy', 'stock-batch-expiry'] as const,
  vendorPurchaseSummary: () => ['dashboard', 'pharmacy', 'vendor-purchase-summary'] as const,
  todaysPharmacyRevenue: () => ['dashboard', 'pharmacy', 'todays-revenue'] as const,
};
